



















import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";

@Component({
  components: {}
})
export default class MoreEntrance extends Vue {
  get entranceList() {
    return [
      {
        icon: require("@/assets/icons-file/more/order@3x.png"),
        text: "Orders",
        iconStyle:
          "background: linear-gradient(rgb(80, 238, 192), rgb(95, 207, 225))",
        clickFunction: () => {
          this.$router.push({
            name: "Orders",
            query: {
              routerTransition: "forward"
            }
          });
        }
      },
      {
        icon: require("@/assets/icons-file/more/coins_store@3x.png"),
        text: "Get Coins",
        iconStyle:
          "background: linear-gradient(rgb(255, 139, 80), rgb(255, 89, 77))",
        clickFunction: () => {
          this.$router.push({
            name: "CoinStore",
            query: {
              routerTransition: "up"
            }
          });
        }
      }
    ];
  }
  private clickItem(fun: any) {
    fun && fun();
  }
}
